import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { SIZE } from '../../../../../constants/size'
import Button from '../../../../Button'
import { Checkbox, CHECKBOX_SIZE, CHECKBOX_TYPE } from '../../../../Checkbox'
import Modal, { Box, Buttons, Content, Header } from '../../../../Modal'

import { getSortedColumns } from './ContractsTableSettingsModal.utils'

import * as styles from './ContractsTableSettingsModal.module.css'

// Local, no-network "Table settings" (column show/hide) for the /library mock
// Contracts tab. The shared `TableConfigModal` fetches a server default config on
// mount, so it can't run without a backend — this lightweight variant takes the
// columns directly. Drag-to-reorder is intentionally omitted for the demo.
function ContractsTableSettingsModal({
  columns,
  requiredColumns,
  setColumns,
  setConfigOpen,
  onApply,
}) {
  const { t } = useTranslation()

  const [initialColumns] = useState(() => structuredClone(columns))

  function handleCancel() {
    setColumns(initialColumns)
    setConfigOpen(false)
  }

  function handleApply() {
    onApply().finally(() => setConfigOpen(false))
  }

  function getHandleToggle(name) {
    return () => {
      setColumns(prevColumns => ({
        ...prevColumns,
        [name]: { ...prevColumns[name], visible: !prevColumns[name].visible },
      }))
    }
  }

  return (
    <Modal onClose={handleCancel}>
      <Box size={SIZE.MEDIUM}>
        <Header
          text={t('Modal.TableSettingsTitleKey')}
          onClose={handleCancel}
        />
        <Content size={SIZE.MEDIUM}>
          {getSortedColumns(columns).map(column => (
            <Checkbox
              checked={column.visible}
              className={styles.checkbox}
              disabled={requiredColumns.includes(column.name)}
              key={column.name}
              label={t(column.title)}
              size={CHECKBOX_SIZE.small}
              type={CHECKBOX_TYPE.table}
              onChange={getHandleToggle(column.name)}
            />
          ))}
        </Content>
        <Buttons size={SIZE.MEDIUM}>
          <Button.Contained
            text={t('Modal.SaveConfigBtnKey')}
            onClick={handleApply}
          />
          <Button.Outlined
            text={t('Modal.CancelBtnKey')}
            onClick={handleCancel}
          />
        </Buttons>
      </Box>
    </Modal>
  )
}

export default ContractsTableSettingsModal
